"use client";

import React from "react";
import { Terminal, Twitter, Instagram, Youtube, ChevronUp, Facebook, ExternalLink } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
const SOCIAL_COORDINATES = [{
  id: "sys.comm.facebook",
  icon: Facebook,
  url: "https://www.facebook.com/mecanizadosindustrialesvene",
  label: "FACEBOOK",
  customStyle: "bg-[hsl(221,44%,50%)] border-[hsl(221,44%,50%)] hover:bg-[hsl(221,44%,50%)]/90"
}, {
  id: "sys.comm.instagram",
  icon: Instagram,
  url: "https://www.instagram.com/mivca.info/?hl=es",
  label: "INSTAGRAM",
  customStyle: "bg-gradient-to-br from-pink-500 to-purple-600 border-transparent hover:opacity-90"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="208981" className="flex flex-col gap-2">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted/20 animate-pulse" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <div className="text-muted-foreground text-sm">_SIN_RUTAS_ACTIVAS</div>;
  }
  return <NavigationMenu viewport={false} className="max-w-full justify-start items-start">
      <NavigationMenuList className="flex-col items-start gap-3">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
          
           
 <NavigationMenuLink asChild>
  {item.href?.includes("dossierMIV-light.pdf") ? <Link to={item.href || "#"} newTab className="group flex items-center text-muted-foreground hover:text-primary transition-colors text-sm tracking-wider uppercase">
      <span className="text-primary mr-2 opacity-0 group-hover:opacity-100 transition-opacity">
        {">"}
      </span>
      {item.label}
    </Link> : <Link to={item.href || "#"} className="group flex items-center text-muted-foreground hover:text-primary transition-colors text-sm tracking-wider uppercase">
      <span className="text-primary mr-2 opacity-0 group-hover:opacity-100 transition-opacity">
        {">"}
      </span>
      {item.label}
    </Link>}

          </NavigationMenuLink>
        </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function TerminalDeSalida() {
  const handleReboot = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  return <section id="cierre-corporativo" className="dark bg-background text-foreground font-mono relative min-h-[525px] overflow-hidden">
      
      <Separator className="bg-primary h-[1px] w-full opacity-50 relative z-10" />

      <div className="container mx-auto px-6 py-16 md:py-24 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 justify-items-center md:justify-items-start">
          
          
          <div className="flex flex-col items-start space-y-6">
            <Link to="/" className="inline-block hover:opacity-80 transition-opacity">
              
            </Link>
          </div>

          
          <div className="flex flex-col items-center space-y-6 py-2">
            <h3 className="text-primary text-sm font-bold tracking-widest uppercase font-default text-center">DOSSIER </h3>
            <MenuProvider menu_id="27">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          
          <div className="flex flex-col space-y-4">
            <h3 className="text-primary text-sm font-bold tracking-widest uppercase font-default text-center">SÍGUENOS </h3>
            <div className="flex flex-col items-center space-y-4">
              <ul className="flex gap-6 md:gap-8 items-center justify-center">
                {SOCIAL_COORDINATES.map((social, i) => {
                const Icon = social.icon;
                return <li key={social.id} data-index={i}>
                      <Link to={social.url} title={social.label} target="_blank" rel="noopener noreferrer" className={`group flex items-center justify-center size-12 rounded-lg border transition-all duration-300 hover:scale-110 ${social.customStyle || "border-primary/30 hover:border-primary hover:bg-primary/10"}`}>
                        <Icon className="size-5 text-white opacity-90 group-hover:opacity-100 transition-opacity" />
                      </Link>
                    </li>;
              })}
              </ul>
            </div>
          </div>

          
          <div className="flex flex-col items-start lg:items-end space-y-6">
            
            <Button variant="outline" onClick={handleReboot} className="rounded-none border-primary text-primary hover:bg-primary hover:text-primary-foreground font-default uppercase tracking-widest h-12 px-6 w-full lg:w-auto group relative overflow-hidden shadow-md">
              <div className="absolute inset-0 bg-primary/10 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" />
              <Terminal className="mr-2 size-4 relative z-10" />
              <span className="relative z-10">INICIO </span>
              <ChevronUp className="ml-2 size-4 relative z-10 opacity-0 group-hover:opacity-100 transition-opacity -translate-y-2 group-hover:translate-y-0 duration-300" />
            </Button>
          </div>

        </div>

        <div className="mt-12 flex flex-col items-center text-center space-y-2">
          <p className="text-sm font-bold text-foreground uppercase tracking-widest">Mecanizados Industriales de Venezuela, C.A.</p>
          <p className="text-xs text-muted-foreground">RIF: J-29412859-9</p>
          <p className="text-xs text-muted-foreground">Sector Belloso, calle 89E con Av. 14A, Maracaibo, Edo. Zulia</p>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-muted-foreground">
            <span>Tel:</span>
            <span>Cel: 0414-6840865</span>
          </div>
          <p className="text-muted-foreground !text-sm">Email: <br />miv@mivgrupo.com<br />mecanizadosindustrialesvene@gmail.com</p>
        </div>

        
        <div className="mt-6 pt-8 border-t border-border/30 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="tracking-widest text-center !text-[hsl(226,71%,40%)] !text-lg md:text-left">© MIV GRUPO - MECANIZADOS INDUSTRIALES DE VENEZUELA - INGENIERÍA DE PRECISIÓN- Website&gt;<span className="group" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:xzldo6" data-ast-start="6698" data-ast-end="8011"><a rel="noopener noreferrer" className="inline-flex items-center decoration-primary/50 underline-offset-4 transition-all duration-300 group-hover:brightness-110 group-hover:underline group-hover:[animation:recla360-hover-glow_3s_ease-in-out_infinite]" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:jkboiy" data-ast-start="6825" data-ast-end="8004" href="https://recla360.com" target="_blank" style={{
              animation: '8s ease-in-out 0s infinite normal none running recla360-glow'
            }}><span className="transition-colors duration-300" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:480z77" data-ast-start="7336" data-ast-end="7507">Recla360.com</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-external-link ml-1 size-3.5" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:n7sob6" data-ast-start="7507" data-ast-end="8000"><path d="M15 3h6v6" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:bayy6y" data-ast-start="7864" data-ast-end="7891"></path><path d="M10 14 21 3" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:bb0sxh" data-ast-start="7891" data-ast-end="7920"></path><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:bbg3vh" data-ast-start="7920" data-ast-end="7994"></path></svg></a></span></p>
        </div>
      </div>
      
      {}
      <div className="absolute inset-0 pointer-events-none z-0 opacity-3.5 md:opacity-6 hidden md:block bg-[url('https://mivgrupo.com/wp-content/uploads/2026/04/logo-miv-mas-ultimo.jpg')] bg-no-repeat bg-center bg-fixed bg-contain" aria-hidden="true" />
      
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] bg-[linear-gradient(45deg,transparent_25%,rgba(0,0,0,.5)_25%,rgba(0,0,0,.5)_50%,transparent_50%,transparent_75%,rgba(0,0,0,.5)_75%,rgba(0,0,0,.5))] bg-[length:20px_20px] z-10" />
    </section>;
}